<!-- src/views/common/Home.vue -->
<template>
  <AccessRequired v-if="showAccessRequired" />
  <div v-else />
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import { useRouter } from 'vue-router';

  import { useAccess } from '@/composables/useAccess';
  import { resolveLandingRoute } from '@/router/landingRoute';
  import AccessRequired from '@/views/common/AccessRequired.vue';

  const router = useRouter();
  const access = useAccess();

  // Set when the caller has no permission this build knows how to route to.
  // We render AccessRequired inline rather than redirecting to a page that
  // requires a permission they don't have — that would just bounce them to
  // Forbidden, whose "go home" action leads right back here (a loop).
  const showAccessRequired = ref(false);

  // MainLayout only renders its router-view once /me has loaded, so access
  // state is always ready by the time this mounts.
  onMounted(() => {
    const landing = resolveLandingRoute(access.hasPermission);
    if (landing) {
      void router.replace({ name: landing });
    } else {
      showAccessRequired.value = true;
    }
  });
</script>
